import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  FilterGrid: {
    'height': '80%',
    'width': '100%',
    '& .dx-datagrid-rowsview .dx-row > td': {
      textOverflow: 'unset'
    }
  },
  lineDetailIcon: {
    cursor: 'pointer'
  }
});
